module.exports = __webpack_public_path__ + "img/header-bg-m-zh.2fa48a64.png";